import { API, Auth } from 'aws-amplify';
import { useEffect } from 'react';

import { CssBaseline, ThemeProvider } from '@material-ui/core';

import Routes from './components/Routes';
import { setupAmplifyConfig } from './config';
import { ProvideAlert } from './hooks/useAlert';
import { ProvideAuth } from './hooks/useAuth';
import globalTheme from './styles/globalTheme';

function App() {
  useEffect(() => {
    const config = setupAmplifyConfig();
    Auth.configure(config.Auth);
    API.configure(config.API);
  }, []);
  return (
    <div className="App">
      <ThemeProvider theme={globalTheme}>
        <CssBaseline />
        <ProvideAlert>
          <ProvideAuth>
            <Routes />
          </ProvideAuth>
        </ProvideAlert>
      </ThemeProvider>
    </div>
  );
}

export default App;
